<script setup>
const props = defineProps({ params: {} });

// File extensions we have an in-app preview for. Anything else gets no
// button — the user can still download via the toolbar.
const VIEWABLE = new Set([
  // PDFs render via <iframe>.
  'pdf',
  // Images render via <img>.
  'png', 'jpg', 'jpeg', 'gif', 'webp', 'svg', 'bmp',
  // Plain-text-ish formats render via <pre>.
  'txt', 'md', 'log', 'json', 'csv', 'tsv', 'yaml', 'yml',
  'xml', 'html', 'htm', 'js', 'ts', 'css', 'py', 'sh', 'ini', 'conf',
]);

const ext = String(props.params.data?.filetype || '').toLowerCase();
const isViewable = VIEWABLE.has(ext);

function onClick(e) {
  e.stopPropagation();
  props.params.context?.openViewer?.(props.params.data);
}
</script>

<template>
  <button v-if="isViewable" class="btn btn-sm btn-link p-1 view-btn" @click.stop="onClick" title="View">
    <font-awesome-icon icon="eye" />
  </button>
</template>

<style scoped>
.view-btn {
  color: #850f5f;
}
</style>
